import { createEventTracker } from '../util';
import {
  ConversionAnalysisAnalytics,
  ConversionAnalysisRunAnalytics,
  GenerateOpportunitiesDisplayedAnalytics,
  GenerateOpportunitiesFailedAnalytics,
  GenerateOpportunitiesStartedAnalytics,
  GenerateOpportunitiesSuccessAnalytics,
} from './types';

export const trackConversionAnalysisCreated = createEventTracker<ConversionAnalysisAnalytics>(
  'Conversion Analysis Created',
);
export const trackConversionAnalysisUpdated = createEventTracker<ConversionAnalysisAnalytics>(
  'Conversion Analysis Updated',
);
export const trackConversionAnalysisDeleted = createEventTracker<ConversionAnalysisAnalytics>(
  'Conversion Analysis Deleted',
);
export const trackConversionAnalysisLoaded = createEventTracker<ConversionAnalysisAnalytics>(
  'Conversion Analysis Loaded',
);
export const trackConversionAnalysisRun = createEventTracker<ConversionAnalysisRunAnalytics>(
  'Conversions Analysis Run',
);

export const trackGenerateOpportunitiesStarted =
  createEventTracker<GenerateOpportunitiesStartedAnalytics>('Generate Opportunities Started');
export const trackGenerateOpportunitiesFailed =
  createEventTracker<GenerateOpportunitiesFailedAnalytics>('Generate Opportunities Failed');
export const trackGenerateOpportunitiesSuccess =
  createEventTracker<GenerateOpportunitiesSuccessAnalytics>('Generate Opportunities Succeeded');
export const trackGenerateOpportunitiesDisplayed =
  createEventTracker<GenerateOpportunitiesDisplayedAnalytics>('Conversion Opportunities Displayed');
